import { HttpClient } from 'api/HttpClient';
import {
  AcceptOfferRequestDto,
  AcceptOfferResponseDto,
  DeclineOfferDto,
  OffersRequestDto,
  OffersResponseDto,
} from 'api/AutomatedOffersApi';

export default class AutomatedOffersApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/small-loan-program/automated-offers');
  }

  public async acceptOffer(acceptOfferDto: AcceptOfferRequestDto): Promise<AcceptOfferResponseDto> {
    return this.instance.post('/accept', acceptOfferDto).then((response) => response.data);
  }

  public async getOffers(offersRequestDto: OffersRequestDto): Promise<OffersResponseDto> {
    return this.instance.post('', offersRequestDto).then((response) => response.data);
  }

  public async declineOffer(declineOfferDto: DeclineOfferDto): Promise<void> {
    return this.instance.put('/decline', declineOfferDto).then((response) => response.data);
  }
}

export const posAutomatedOffersApi = new AutomatedOffersApi();
